var getCustomerPoints = (c, pointsPaymentValue) => {
  if (c === null) {
    return 0;
  }

  switch (pointsPaymentValue) {
    case "sas_extrapoints":
      return c ? c.sasExtraPoints : 0;

    case "awardit":
    default:
      return Number.parseInt(c.awardit.activePoints, 10);
  }
};

export { getCustomerPoints };
//# sourceMappingURL=customer.js.map
